import { render, staticRenderFns } from "./MaliciousCuts.vue?vue&type=template&id=467c6a48&scoped=true"
import script from "./MaliciousCuts.vue?vue&type=script&lang=js"
export * from "./MaliciousCuts.vue?vue&type=script&lang=js"
import style0 from "./MaliciousCuts.vue?vue&type=style&index=0&id=467c6a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c6a48",
  null
  
)

export default component.exports